import { fetchQaCalibrationReviewers } from './fetchQaCalibrationReviewers';
import { fetchQaCalibrations } from './fetchQaCalibrations';
import { raiseQaCalibrationDispute } from './raiseQaCalibrationDispute';
import { resolveQaCalibrationDispute } from './resolveQaCalibrationDispute';
import { submitQaCalibration } from './submitQaCalibration';

export const qaCalibrationService = { fetchQaCalibrationReviewers, fetchQaCalibrations, raiseQaCalibrationDispute, resolveQaCalibrationDispute, submitQaCalibration };
